export const isFeriadoFilter = (date: Date, feriados: Array<Date> | undefined) => {
    
    if (feriados === undefined) {
        return true
    }
    else if (feriados.length === 0) {
        return true
    }

    
    const feriadosDates:Date[] = feriados.map((val,indi) => {
        return new Date(val)
    })

    var time_fecha = date.getTime();
    var indice_fecha: number = feriadosDates.findIndex((fer) => fer.getTime() == time_fecha);
    return indice_fecha == -1
}

export const isWeekday = (date: Date) => {
    if(date === null){
        return false
    }
    const day = date.getDay();
    return day !== 0 && day !== 6;
};

export function getLastWorkdayOfYear(year: number): Date {
    // Create a date for the last day of the year
    const lastDayOfYear = new Date(year, 11, 31); // Month is 0-indexed, so 11 is December
  
    // Get the day of the week (0 is Sunday, 1 is Monday, ..., 6 is Saturday)
    let dayOfWeek = lastDayOfYear.getDay();
  
    // Check if the last day is a weekend (Saturday or Sunday)
    if (dayOfWeek === 0 /* Sunday */ || dayOfWeek === 6 /* Saturday */) {
      // If it's a weekend, move back to the previous Friday
      lastDayOfYear.setDate(lastDayOfYear.getDate() - (dayOfWeek === 0 ? 2 : 1));
    }
  
    return lastDayOfYear;
  }

export const isFeriado = (date: Date, feriados: Array<Date> | undefined) => {
    if (feriados === undefined) {
        return ""
    }
    else if (feriados.length === 0) {
        return ""
    }

    const feriadosDates:Date[] = feriados.map((val,indi) => {
        return new Date(val)
    })

    var time_fecha = date.getTime();
    var indice_fecha: number = feriadosDates.findIndex((fer) => fer.getTime() == time_fecha);
    if (indice_fecha !== -1) {
        return "feriadoDay"
    }
    return ""
}